import { render, staticRenderFns } from "./ModalHabilitarFornecedor.vue?vue&type=template&id=a6ea046a&"
import script from "./ModalHabilitarFornecedor.vue?vue&type=script&lang=js&"
export * from "./ModalHabilitarFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports